import React, { useState } from "react";
import companyLogo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";

function SignUpForm({ setForm }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const setFormToLogin = () => {
    setForm("login");
  };

  const setFormToForgotPassword = () => {
    setForm("forgotpassword");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
    const company = e.target.company.value;
    const phone = e.target.phone.value;
    signUpUser();

    async function signUpUser() {
      alert("Signup not availabe right now.");
      // const response = await fetch("/api/signup", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   credentials: "include",
      //   body: JSON.stringify({
      //     email: email,
      //     password: password,
      //     company: company,
      //     phone_number: phone,
      //   }),
      // });

      // const data = await response.json();
      // if (!response.ok) {
      //   alert("User already exists");
      //   return;
      // } else {
      //   navigate("/sites");
      // }
    }
  };
  return (
    <div className="w-full md:w-2/5 bg-black text-white">
      <img src={companyLogo} alt="Company Logo" className="mb-8 p-20" />
      <div className="w-full flex flex-col justify-center items-center bg-black text-white">
        <div className="max-w-md w-full">
          <h2 className="text-3xl font-bold mb-8">Create Account</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block mb-1" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                required
                className="w-full p-2 border border-gray-300 rounded-lg text-black"
              />
            </div>
            <div className="mb-6">
              <label className="block mb-1" htmlFor="password">
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                required
                className="w-full p-2 border border-gray-300 rounded-lg text-black"
              />
              <div className="mt-2">
                <input
                  type="checkbox"
                  id="showPassword"
                  checked={showPassword}
                  onChange={() => setShowPassword(!showPassword)}
                />
                <label htmlFor="showPassword" className="ml-2">
                  Show Password
                </label>
              </div>
            </div>
            <div className="mb-4">
              <label className="block mb-1" htmlFor="email">
                Company Name
              </label>
              <input
                type="text"
                id="company"
                required
                className="w-full p-2 border border-gray-300 rounded-lg text-black"
              />
            </div>
            <div className="mb-4">
              <label className="block mb-1" htmlFor="email">
                Phone number
              </label>
              <input
                type="text"
                id="phone"
                required
                className="w-full p-2 border border-gray-300 rounded-lg text-black"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-[#2d9376] text-white py-2 px-4 rounded-lg hover:bg-green-600"
            >
              Sign Up
            </button>
            <div className="mt-4 text-center">
              Already have an account? &nbsp;
              <a
                href="#"
                className="text-[#2d9376] hover:underline"
                onClick={setFormToLogin}
              >
                Sign In
              </a>
            </div>
            <div className="mt-4 text-center">
              <a
                href="#"
                className="text-[#2d9376] hover:underline"
                onClick={setFormToForgotPassword}
              >
                Forgot your password?
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SignUpForm;
